export default __webpack_public_path__ + "static/media/greenBG.3745b5e2.svg";